import type { ReactNode } from 'react'
import SettingCard from '../SettingCard'
import PaymentStatusPill, { type PaymentChannelStatus } from './PaymentStatusPill'

interface Props {
  title: string
  subtitle?: string
  status: PaymentChannelStatus
  keys: string[]
  onSave: (keys: string[], overrides?: Record<string, string>) => Promise<unknown>
  onReload?: () => void
  saving?: boolean
  validate?: () => string | null
  confirmMessage?: string
  children: ReactNode
}

/** 支付渠道卡：顶部状态 Pill + SettingCard 保存区 */
export default function PaymentChannelCard({
  title,
  subtitle,
  status,
  keys,
  onSave,
  onReload,
  saving,
  validate,
  confirmMessage,
  children,
}: Props) {
  return (
    <SettingCard
      title={
        <span className="inline-flex items-center gap-2 flex-wrap">
          {title}
          <PaymentStatusPill status={status} />
        </span>
      }
      subtitle={subtitle}
      keys={keys}
      onSave={onSave}
      onReload={onReload}
      saving={saving}
      validate={validate}
      confirmMessage={confirmMessage}
    >
      {children}
    </SettingCard>
  )
}
